<template>
    <div class="review" v-loading="loader">
        <div class='filters'>
            <div class="card">
                <div class='card-header'>
                    <h3 class='card-title'>Filtres</h3>
                    <div class="card-options">
                        <el-dropdown>
                            <el-button type="primary">
                                Export<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="exportProducts('update')">Pour mise à jours</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <a href="#" v-if="user.can('catalogue importer')" @click="displayDialogImport()" class="btn btn-secondary btn-sm ml-2">Importer</a>
                    </div>
                </div>



                <el-form ref="filtersForm" :model="filters" label-position="top">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <el-form-item prop="change_type" label="Type de changement">
                                    <el-select clearable v-model="filters.change_type" placeholder="Type de changement">
                                        <el-option label="Ajout / Modification Code barre" value="ean13"/>
                                        <el-option label="Ajout de variation" value="variation_added"/>
                                        <el-option label="Changement de taille" value="variation_value_size"/>
                                        <el-option label="Hybridation" value="hybridation"/>
                                        <el-option label="Suppression de variations" value="deleted_variation"/>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-md-3">
                                <el-form-item prop="error_type" label="Type d'erreur">
                                    <el-select clearable v-model="filters.error_type" placeholder="Type d'erreur">
                                        <el-option label="Toutes" value="all"/>
                                        <el-option label="Prix" value="price"/>
                                        <el-option label="Code barre" value="ean13"/>
                                        <el-option label="Image par défaut" value="defaultImage"/>
                                        <el-option label="Variation en double" value="doublonVariation"/>
                                        <el-option label="Variation vide" value="emptyVariation"/>
                                        <el-option label="Meta title en double" value="doublonMetaTitle"/>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="col-md-3" v-loading="loaderProductTypeOptions">
                                <el-form-item prop='product_type' label="Type de produit">
                                    <el-select clearable filterable v-model="filters.product_type">
                                        <el-option
                                            v-for="product_type in productTypeOptions"
                                            :key="product_type.id"
                                            :label="product_type.value"
                                            :value="product_type.id"
                                        />
                                    </el-select>

                                </el-form-item>
                            </div>

                            <div class="col-md-3" v-loading="loaderProductBrandOptions">
                                <el-form-item prop='product_brand' label="Marque">
                                    <el-select clearable filterable v-model="filters.product_brand">
                                        <el-option
                                            v-for="product_brand in productBrandOptions"
                                            :key="product_brand.id"
                                            :label="product_brand.name"
                                            :value="product_brand.id"
                                        />
                                    </el-select>

                                </el-form-item>
                            </div>

                            <div class="col-md-3" v-loading="loaderReviewerOptions">
                                <el-form-item prop='reviewer_id' label="Auteurs">
                                    <el-select clearable v-model="filters.reviewer_id">
                                        <el-option
                                            v-for="reviewer in reviewerOptions"
                                            :key="reviewer.id"
                                            :label="reviewer.name"
                                            :value="reviewer.id"
                                        />
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-md-3" v-loading="loaderReviewerOptions">
                                <el-form-item prop="stock" label="Stock" >
                                    <el-radio-group  v-model="filters.stock">
                                        <el-radio-button :label="false">Sans</el-radio-button>
                                        <el-radio-button :label="null">Désactivé</el-radio-button>
                                        <el-radio-button :label="true">Avec</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>

                <div class="card-footer">
                    <div class="pull-right">
                        <el-button @click="resetFilters" type="info" plain>Annuler</el-button>
                        <el-button @click="onUpdateFilters" type="primary">Valider</el-button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>

        <div class="product-list">

            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} produits</div>
                <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
            </div>

            <template v-if="multipleSelection.length">
                <el-button @click="modalConfirm = true" >Syncroniser les informations sur le prestashop</el-button>
                <el-button type="warning" @click="removeReview" >Supprimer de la review</el-button>
            </template>

            <template v-if="user.email == 'info@divioseo.fr'">
                <el-button type="default" @click="removeReview('all')" >reset review</el-button>
            </template>

            <hr>

            <el-table style="width: 100%" ref="multipleTable" :row-class-name="tableRowClassName" :cell-class-name="cellClassName" :data="products" @selection-change="handleSelectionChange" stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="activated" label="Activé/Stock" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <div>
                            <span>Stock PIM : <span v-html='booleanValue(scope.row.has_stock)'></span></span><br>
                            <span>Stock SP : <span v-html='booleanValue(scope.row.presta_stock)'></span></span><br>
                            <span>Actif site : <span v-html='booleanValue(scope.row.presta_activated)'></span></span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="visuel" width="55">
                    <template slot-scope="scope">
                        <el-badge :value="scope.row.images.length" class="item">
                            <a v-if="scope.row.images.length" href="#" @click.prevent="openLightbox(scope.row.image)" class="mb-3">
                                <span class="avatar" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.image.path+'\')'}"></span>
                            </a>
                        </el-badge>
                    </template>
                </el-table-column>
                <el-table-column prop="shop_id" label="Ref Speedway / ID" sortable="custom" width="150">
                    <template slot-scope="scope">
                        {{ scope.row.shop_id }}
                        <span v-if="scope.row.sync_put_status">&nbsp;
                            <el-badge  value=" " v-if="scope.row.sync_put_status=='processed'" type="success" class="item">&nbsp;</el-badge>
                            <el-badge  value=" " v-else-if="scope.row.sync_put_status=='processing'" type="warning" class="item">&nbsp;</el-badge>
                            <el-badge  value=" " v-else-if="scope.row.sync_put_status=='failed'" type="danger" class="item">&nbsp;</el-badge>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Titre" sortable="custom" >
                    <template slot-scope="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column prop="brand" label="Marque" sortable="custom">
                    <template slot-scope="scope">
                        <span v-if="scope.row.brand">{{ scope.row.brand.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="external_ref" label="Ref fournisseur" sortable="custom" width="200">
                    <template slot-scope="scope">
                        {{ scope.row.mf_prefixe }} / {{ scope.row.external_ref }}
                    </template>
                </el-table-column>
                <el-table-column prop="mf_price_public" label="Prix public Fournisseur" sortable="custom" width="90">
                </el-table-column>
                <el-table-column prop="variationsCount" label="Variations" sortable="custom" width="90">
                    <template slot-scope="scope">
                        <a :title="scope.row.variationsIds" href="#" @click.prevent="openVariations(scope.row)">
                            <span v-if="scope.row.variationsCount">
                                <el-badge type="danger" :value="scope.row.variationsCount" class="item">
                                    O
                                </el-badge>
                            </span>
                            <span v-else>N</span>
                        </a>
                    </template>
                </el-table-column>
                <el-table-column prop="review_at" label="Date review" sortable="custom" width="170">
                    <template slot-scope="scope">
                        <span :class="{
                            'is-recent': scope.row.review_direction == 'pim->prestashop'
                        }">{{ scope.row.review_at }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="review_user_name" label="Utilisateur" sortable="custom" >
                    <template slot-scope="scope">
                        {{ scope.row.review_user_name }}
                    </template>
                </el-table-column>
                <el-table-column label="Commentaire" sortable="custom" width="230">
                    <template slot-scope="scope">
                        <div class="comment-input nl2br">
                            <template v-if="!scope.row.commentActive && scope.row.comment">
                                <el-tooltip placement="top">
                                    <div slot="content" class="nl2br" v-html="scope.row.comment"></div>
                                    <span @click="scope.row.commentActive = true" v-html="truncateString(scope.row.comment, 100)"></span>
                                </el-tooltip>
                            </template>
                            <template v-if="!scope.row.commentActive && !scope.row.comment">
                                <a href="#" @click.prevent="scope.row.commentActive = true">
                                    <i class="fe fe-edit"></i>
                                </a>
                            </template>
                            <template v-if="scope.row.commentActive">
                                <el-input   @change="() => saveComment(scope.row)" placeholder="commentaire" type="textarea" :rows="2" v-model="scope.row.comment"></el-input>
                                <a href="#" @click.prevent="saveComment(scope.row)">
                                    <i class="fe fe-save"></i>
                                </a>
                            </template>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="review_direction" label="Sens" sortable="custom" width="80">
                    <template slot-scope="scope">
                        <strong v-if="scope.row.review_direction == 'pim->prestashop'"> => </strong>
                        <strong v-if="scope.row.review_direction == 'pim<-prestashop'"> <= </strong>
                    </template>
                </el-table-column>
                <el-table-column prop="review_prestashop_update" label="Date Prestashop" sortable="custom" width="170">
                    <template slot-scope="scope">
                        <span :class="{
                            'is-recent': scope.row.review_direction == 'pim<-prestashop'
                        }">{{ scope.row.review_prestashop_update }}</span>
                        <span v-if="!scope.row.review_prestashop_update">Création du produit sur le prestashop</span>
                    </template>
                </el-table-column>
                <el-table-column label="Actions" prop="syncronized_at" sortable="custom" fixed="right"  width="80">
                    <template slot-scope="scope">
                        <a class="icon" v-if="!scope.row.review_errors">
                            <i class="fe fe-check-square text-success"></i>
                        </a>
                        <a class="icon" v-if="scope.row.review_errors" @click="openModalErrors(scope.row)">
                            <i class="fe fe-alert-triangle text-danger"></i>
                        </a>
                        <a class="icon" @click="openModalDifference(scope.row)">
                            <i class="fe fe-eye"></i>
                        </a>
                        <a class="icon" @click="openModalChange(scope.row)">
                            <i class="fe fe-git-branch"></i>
                        </a>
                        <a :title="scope.row.id" class="icon" v-if="user.can('edit product')" @click="openModalEdit(scope.row)">
                            <i class="fe fe-edit"></i>
                        </a>
                        <span v-if="scope.row.syncronized_at_human">
                            <br><small><i class="fe fe-watch"></i> {{ scope.row.syncronized_at_human }}</small>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>
        </div>

        <el-dialog class="lightbox-galery" @closed="cleanLigtbox" :visible.sync="lightbox.display" fullscreen append-to-body>
            <div slog="title">
                <h4>{{ lightbox.image.filename }}</h4>
                <span v-for="(tag, indexTag) in lightbox.image.tags" :key="indexTag" class="badge badge-secondary mx-1">{{ tag.name }}</span>
            </div>
            <div class="lightox-galery-ctn my-3" v-loading="lightbox.loader" v-if="lightbox.image.path">
                <img @load="lightbox.loader = false" :src=" '/ic/original/' + lightbox.image.path" :alt="lightbox.image.filename">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="lightbox.display = false">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Différence données Speedway / Fournisseur" :visible.sync="modalDifference.display" width="95%" top="2vh" bottom="2vh">
            <product-difference style="height:77vh;overflow-x: auto;" :product="modalDifference.product"></product-difference>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="appEnv != 'production'" @click="sync('pull', modalDifference.product)" type="info" plain>Utiliser les informations de Prestashop</el-button>
                <el-button v-if="appEnv != 'production'" @click="sync('put', modalDifference.product)" type="warning" plain>Utiliser les informations du PIM</el-button>
                <el-button @click="closeModalDifference">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Attention - Syncroniser les produits ?" :visible.sync="modalConfirm" width="30%" @closed="handleCloseModalConfirm" >
            <div class="warning-zone">
                <el-checkbox v-model="configSync['override-images']">Forcer le remplacement des images ?</el-checkbox>
                <el-checkbox v-model="configSync['force-slug']">Forcer le remplacement des URL rewrite ?</el-checkbox>
                <el-select v-model="configSync['force-new']">
                    <el-option :value="null" label="Nouveauté ?"></el-option>
                    <el-option :value="'Non'" label="Non"></el-option>
                    <el-option :value="'Oui'" label="Oui"></el-option>
                </el-select>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalConfirm = false">Annuler</el-button>
                <el-button type="primary" @click="syncSelected">Confirmer</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Changements" :visible.sync="modalChange" width="50%" >

            <template v-if="modalChangeProduct && modalChangeProduct.review_change">
                <div v-for=" (change, type) of modalChangeProduct.review_change " :key="type">
                    <strong>{{ type }}</strong>
                    <template v-if=" ['price', 'ean13'].indexOf(type) != -1 ">
                        <p>
                            <strong>Ancien</strong> : {{  change.old }} <br>
                            <strong>Nouveau</strong> : {{ change.new }}
                        </p>
                        <hr>
                    </template>
                    <template v-if=" ['price_variation', 'ean13_variation', 'variation_value_size'].indexOf(type) != -1 ">
                        <ul>
                            <li v-for="(vChange, iChange) in change" :key="iChange">
                                <strong>Ancien</strong>  : {{  vChange.old }} <br>
                                <strong>Nouveau</strong> : {{ vChange.new }} <br>
                                <strong>Variation</strong> : {{ vChange.variation.external_ref }}
                            </li>
                        </ul>
                        <hr>
                    </template>
                    <template v-if=" ['variation_added'].indexOf(type) != -1 ">
                        <ul>
                            <li v-for="(vChange, iChange) in change" :key="iChange">
                                <strong>Variation</strong> : {{ vChange.variation.external_ref }}
                            </li>
                        </ul>
                        <hr>
                    </template>
                    <template v-if=" ['deleted_variation'].indexOf(type) != -1 ">
                        <ul>
                            <li v-for="(vChange, iChange) in change" :key="iChange">
                                <strong>Variation</strong> : {{ vChange.variation.external_ref }} - {{ vChange.variation.variation_value.value }}
                                <button type='button' class='btn btn-link' title='restaurer la variation' @click='restore_variation(vChange.variation.id, vChange.variation.product_id)'><i class="fe fe-rotate-ccw"></i></button>
                            </li>
                        </ul>
                        <hr>
                    </template>
                    <template v-if=" ['remove_group'].indexOf(type) != -1 ">
                        <p>
                            <strong>Groupe supprimer</strong> : {{ change.group_name }}
                        </p>
                        <hr>
                    </template>
                    <template v-if=" ['add_group'].indexOf(type) != -1 ">
                        <p>
                            <strong>Groupe ajouter</strong> : {{ change.group_name }}
                        </p>
                        <hr>
                    </template>
                    <template v-if=" ['name_group'].indexOf(type) != -1 ">
                        <p>
                            <strong>Ancien</strong>  : {{  change.old }} <br>
                            <strong>Nouveau</strong> : {{ change.new }} <br>
                        </p>
                        <hr>
                    </template>
                </div>
            </template>


            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="modalChange = false">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Erreurs" :visible.sync="modalErrors" width="80%" >
            <template v-if="modalErrorsProduct">
                <div v-for="(errors, key) in modalErrorsProduct.review_errors" :key="key">
                    <div class="mt-3" v-for="(error, keyError) in errors" :key="keyError">
                        <strong>{{ error.msg }}</strong> <span v-if="error.ref">({{ error.ref }})</span>
                        <span v-if="error.value && error.value.constructor !== Array"> : {{ error.value }} <span v-if="error.initialValue">({{ error.initialValue }})</span></span>
                        <div v-if="error.value && error.value.constructor === Array ">
                            <div class="d-flex" v-for="(el, elKey) in error.value" :key="elKey">
                                <div class="ml-2" v-for="c in Object.keys(el)" :key="c">
                                    <strong>{{ c }}</strong> : {{ el[c] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>


            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="modalErrors = false">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog @closed="unlock(modal.product.id)" :title="'Edition produit #' + modal.product.shop_id" :visible.sync="modal.display" :close-on-click-modal="false" width="90%" top="1vh">
            <catalog-edit from="review" :fetch="true" :product="modal.product" :products-id="productsId" @update-product="onUpdateProduct" @edit-next="editNext" ></catalog-edit>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeModalEdit(modal.product.id)">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Import" @close="closeDialogImport" :visible.sync="dialogImport.display" :fullscreen="true" v-loading="dialogImport.loader">
            <el-upload :on-progress="importUploadStart" :on-success="importUploaded" ref="uploadImport" :headers="dialogImport.headersUpload" action="/products/import" >
                <el-button slot="trigger" size="small" type="primary">Choisir un fichier</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="!dialogImport.processing" @click="closeDialogImport()">Annuler</el-button>
                <el-button v-if="dialogImport.ended" @click="closeDialogImport()">Fermer</el-button>
                <el-button v-if="!dialogImport.processing" type="primary" @click="closeDialogImport()">Confirmer</el-button>
            </span>
        </el-dialog>

        <el-dialog @closed="modalVariationClosed" title="Variations de produit" :close-on-press-escape="false" :visible.sync="modalVariations.display" width="95%" top="2vh" bottom="2vh">
            <product-variations @removed="variationRemoved" @added="variationAdded" :product="modalVariations.product"></product-variations>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeVariations">Fermer</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import { EventBus } from '../../event-bus';
import Product from '../../models/Product';
import { filterCascader } from '../filters';

export default {
    data() {
        return {
            multipleSelection: [],
            modalConfirm: false,
            modalChange: false,
            modalChangeProduct: null,
            modalErrors: false,
            modalErrorsProduct: null,
            configSync: {
                'override-images': false,
                'force-slug': false,
                'force-new': null
            },
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'updated_at',
                order: 'DESC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'updated_at',
                order: 'DESC',
                limit: 10
            },
            filters: {
                'change_type': null,
                'error_type': null,
                'product_type': null,
                stock: null,
            },
            productTypeOptions: [],
            loaderProductTypeOptions: false,
            productBrandOptions: [],
            loaderProductBrandOptions: false,
            reviewerOptions: [],
            loaderReviewerOptions: false,
            loading: false,
            modalDifference: {
                display: false,
                product: {}
            },
            lightbox: {
                display: false,
                image: {},
                loader: true
            },
            modal: {
                display: false,
                product: {}
            },
            dialogImport: {
                processing: false,
                loader: false,
                path: null,
                display: false,
                headersUpload: {
                    'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
                },
            },
            modalVariations: {
                display: false,
                product: {}
            },
        };
    },
    computed: {
        total_item() {
            return this.$store.getters['products/totalItems'];
        },
        products() {
            return this.$store.getters['products/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
        loader: {
            get() {
                return this.$store.getters['products/loader'];
            },
            set(value) {
                this.$store.dispatch('products/setLoader', value);
            }
        },
        appEnv() {
            return this.$store.getters['app/env'];
        },
        user() {
            return this.$store.getters['app/user'];
        },
        productsId() {
            return this.$store.getters['products/items'].map(v => v.id);
        },
    },
    mounted() {
        this.fetch();
        EventBus.$on('products.list.refresh', () => {
            this.fetch();
        });

        // Load product type
        this.loaderProductTypeOptions = true;
        axios.get('/filters/features/typesProduct?orderBy=value&order=asc').then(r => {
            this.productTypeOptions = r.data.data;
        }).then(()=>{
            this.loaderProductTypeOptions = false
        });

        // Load product brand
        this.loaderProductBrandOptions = true;
        axios.get('/brands?mode=list&limit=-1').then(r => {
            this.productBrandOptions = r.data.data;

        }).then(()=>{
            this.loaderProductBrandOptions = false
        });

        // Load reviewer
        this.loaderReviewerOptions = true;
        axios.get('/filters/authors').then(r => {
            this.reviewerOptions = r.data;
        }).then(()=>{
            this.loaderReviewerOptions = false
        });
    },

    methods: {
        async saveComment(product) {
            let response = await axios.post('/products/' + product.id, {
                data: product,
                mode: 'comment'
            })
            product.commentActive = false
            this.updateProductInList(product.id, response.data.data)
        },
        cellClassName({row, column, rowIndex, columnIndex}) {
            var className = '';
            if(column.label == 'Commentaire' && row.commentActive == true) {
                className = className + ' opacity-100'
            }
            return className
        },
        editNext(productId)
        {
            this.openModalEdit({id: productId})
        },
        tableRowClassName({row, rowIndex}) {
            var className = 'manufacturer-' + row.manufacturer_slug;
            if(row.is_stock_hybrid !== null){
                className = className + ' hybrid';
            }
            if( row.end_of_life ) {
                if( row.has_stock){
                    className = className + ' end-of-life';
                }else{
                    className = className + ' very-end-of-life';
                }
            }
            return className;
        },
        handleSelectionChange(val) {
            this.$store.dispatch('products/setApplyToAllResults', false);
            this.multipleSelection = val;
        },

        cleanTypeParams(params) {
            for (let i in params) {
                if (params[i] == 'false') {
                    params[i] = false;
                } else if (params[i] == 'true') {
                    params[i] = true;
                }
            }
            return params;
        },


        fetch(params) {
            if (!params) {
                params = {};
            }
            params = this.cleanTypeParams({ ...params, ...this.params });
            this.loading = true;
            return this.$store.dispatch('products/review', params).then(() => {
                this.loading = false;
            });
        },


        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },


        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },


        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.catalog .product-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },

        openModalDifference(product) {
            axios.get('/products/'+product.id).then((r)=>{
                this.modalDifference.display = true;
                this.modalDifference.product = r.data.data;
            })
        },

        closeModalDifference() {
            this.modalDifference.display = false;
        },

        openModalChange(product) {
            this.modalChange = true;
            this.modalChangeProduct = product;
        },

        openModalErrors(product) {
            this.modalErrors = true;
            this.modalErrorsProduct = product;
        },

        openLightbox(image) {
            this.lightbox.loader = true;
            this.lightbox.image = {};
            this.$nextTick(function() {
                this.lightbox.image = image;
                this.lightbox.display = true;
            });
        },
        cleanLigtbox() {
            this.lightbox = {
                display: false,
                image: {},
                loader: true
            };
        },
        handleCloseModalConfirm()
        {
            this.configSync['override-images'] = false;
        },
        syncSelected()
        {
            let selected = this.multipleSelection.map(v=>v.id);

            axios.post('/products/syncMany', {
                products: selected,
                config: this.configSync,
                direction: 'put'
            }).then(()=>{
                this.fetch()
                this.configSync['override-images'] = false;
                this.modalConfirm = false;
            })

        },
        removeReview( type = 'selected' )
        {
            this.$confirm('Êtes-vous sûr ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
            .then(() => {
                let selected = this.multipleSelection.map(v=>v.id);

                axios.post('/products/removeReview', {
                    products: selected,
                    type: type
                }).then(()=>{
                    this.fetch()
                })
            }).catch(()=>{

            })

        },
        openModalEdit(product) {
            axios.post('products/'+ product.id+'/lock').then((r)=>{
                if(r.data.data === false){
                    this.$notify({
                        title: 'Attention',
                        message: 'Ce produit est déjà en cours d\'édition par un autre utilisateur.',
                        type: 'warning'
                    });
                }else{
                    axios.get('products/'+ product.id).then((r)=>{
                        this.modal.product = new Product(r.data.data);
                        this.modal.display = true;
                    })
                }
            })
        },
        unlock(id) {
            axios.post('products/'+ id+'/unlock').then((r)=>{
            })
        },
        closeModalEdit(id) {
            this.modal.display = false;
            //this.modal.product = {};
        },
        onUpdateProduct(product) {
            this.closeModalEdit(product.id);
        },

        resetFilters() {
            this.$refs.filtersForm.resetFields();
            this.$store.dispatch('app/setQ', null);
            this.onUpdateFilters();
        },
        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },
        onUpdateFilters() {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...this.filters };
            if (!Object.values(this.filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },
        exportProducts() {
            var params = this.cleanTypeParams({ ...this.params });
            axios
                .post('/review/export', params )
                .then(r => {
                    this.$notify.info({
                        title: 'Info',
                        message: r.data.message
                    });
                })
                .catch(() => {})
                .then(() => {});
        },
        importUploaded(response, file, fileList)
        {
            this.dialogImport.loader = false
            this.$notify.info({
                title: 'Info',
                message: response.message
            });
            this.closeDialogImport();
        },
        importUploadStart(e, file, fileList)
        {
            this.dialogImport.loader = true
        },
        displayDialogImport()
        {
            this.dialogImport.display = true
        },
        closeDialogImport()
        {
            this.dialogImport.path = null;
            this.dialogImport.processing = false;
            this.dialogImport.ended = false;
            this.dialogImport.loader = false;
            this.dialogImport.display = false;
            this.$refs.uploadImport.clearFiles()
        },
        filterCascader(node, keyword) {
            return filterCascader(node, keyword)
        },
        restore_variation(productVariationValueId, productId) {
            this.$confirm('Voulez-vous restaurer la variation', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    axios
                        .post(
                            '/products/' +
                            productId +
                            '/variations/' +
                            productVariationValueId,
                            {
                                mode: 'restore'
                            }
                        )
                        .then(r => {
                            let that = this;
                            axios.get('products/'+ this.modalChangeProduct.id)
                                .then((d) => {
                                    let payload = {
                                        id: that.modalChangeProduct.id,
                                        data: d.data.data
                                    };
                                    this.$store.dispatch('products/updateInList', payload);
                                })
                        })
                        .catch(() => {})
                        .then(() => {
                        });
                })
                .catch(() => {});
        },
        truncateString(string, size)
        {
            var truncated = string
            if(truncated.length > size) {
                truncated = truncated.substring(0, size) + ' ...'
            }
            return truncated
        },
        openVariations(product) {
            this.modalVariations.product = product.clone();
            this.modalVariations.display = true;
        },

        closeVariations() {
            this.modalVariations.product = {};
            this.modalVariations.display = false;
        },
        modalVariationClosed() {
            EventBus.$emit('modal.variations-product.closed');
        },
        variationAdded({ variation, productId }) {
            var finded = this.products.find(v => v.id == productId);
            if (finded) {
                finded.variationsCount += 1;
            }
        },
        variationRemoved({ variation, productId }) {
            var finded = this.products.find(v => v.id == productId);
            if (finded) {
                finded.variationsCount -= 1;
            }
        },
        booleanValue(value) {
            if(value) {
                return '<strong class="text-success">O</strong>';
            } else {
                return '<strong class="text-danger">N</strong>';
            }
        }
    }
};
</script>
<style lang="scss">
.review {
    .pagination {
        margin: 25px 0;
        .el-pagination {
            margin: 0 auto;
        }
    }
    .is-recent {
        font-weight: bold;
        color: #009e2c;
    }
    .manufacturer-speedway {
        background-color: #b7ffdb47;
        &.hybrid{
            background-color: #e1b7ffe6;
        }
    }

    .very-end-of-life {
        background-color: #cc4747e6;
        color: #FFF;
    }

    .end-of-life {
        background-color: #ec8c4be6;
        color: #FFF;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.very-end-of-life td {
        background-color: #cc5f5fe6;
        color: #FFF;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.end-of-life td {
        background-color: #ec9b65e6;
        color: #FFF;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.manufacturer-speedway td {
        background-color: #b7ffdb47;
    }
    .warning-zone {
        color: #e6a23c;
        background-color: #fdf6ec;
        padding: 8px 16px;
        box-sizing: border-box;
        border-radius: 4px;
        width: 100%;
        .el-checkbox__label {
            color: #e6a23c;
        }
    }
}

.lightbox-galery {
    .el-dialog__body {
        height: 89vh;
        text-align: center;
        .lightox-galery-ctn {
            height: 77vh;
        }
        img {
            height: 100%;
            object-fit: contain;
        }
    }
}
.el-table__row {
    .el-badge__content.is-fixed {
        top: 10px;
        line-height: 14px;
    }
}
</style>
